import { render, staticRenderFns } from "./ModalPriorities.vue?vue&type=template&id=47e6c95b&scoped=true&"
import script from "./ModalPriorities.vue?vue&type=script&lang=js&"
export * from "./ModalPriorities.vue?vue&type=script&lang=js&"
import style0 from "./ModalPriorities.vue?vue&type=style&index=0&id=47e6c95b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e6c95b",
  null
  
)

export default component.exports